import React from "react";
import ContactHero from "../components/contact/ContactHero";
import ContactForm from "../components/homepage/ContactForm";

const Contact = () => {
  return (
    <>
      <ContactHero />
      <ContactForm />
    </>
  );
};

export default Contact;
